import { render, staticRenderFns } from "./Week.vue?vue&type=template&id=0c73f74f&scoped=true&"
import script from "./Week.vue?vue&type=script&lang=js&"
export * from "./Week.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c73f74f",
  null
  
)

export default component.exports